import React from "react";
import {
  InputSearch,
  PageHeader,
  ListActionIcon,
  PositionActionIcon,
  CountryCardSelection,
  CategoryCardSelection,
  AddressCardSelection,
  Button,
  Modal,
  Message,
  Spinner,
  Pagination,
} from "dab-component-lib";
import { withRouter } from "react-router";
import { graphql, compose } from "react-apollo";
import axios from "axios";
import _ from "lodash";
import {
  SEARCH_ADDRESS,
  LAST_ADDRESS,
  GETBASKETS,
} from "../../utils/constants";
import {
  createNodeCartLineItem,
  createNodeCartLineItemWithSizes,
  currencyById,
  currentUserCart,
  currentUserQuery,
  deleteNodeCartLineItem,
  getText,
  productByCode,
} from "../../queries";
import I18n from "../../I18n/I18n";

import {
  DeselectedAreaStyle,
  OrderRowStyle,
  OrderColStyle,
  IconWithTitleWrapperStyle,
  IconWrapperStyle,
  TitleStyle,
  SubtitleStyle,
  ButtonWrapperStyle,
  ResultsWrapperStyle,
  CategoryRowStyle,
  FullWidthStyle,
  InputSearchWrapper,
} from "./style";
import {
  GridContainerStyle,
  PageHeaderWrapperStyle,
  LoadingStyle,
} from "../../utils/style-utils";

let addresses = [];
let improvedLastAddress = {};

class OrderDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedLocation: null,
      selectedCategory: null,
      selectedBasket: null,
      firstTimeSearch: true,
      disable: false,
      selectedAddress: null,
      disableButton: true,
      results: [],
      error: false,
      loading: false,
      roles: [],
      showModal: false,
      lastAddress: null,
      dtrainingAddress: null,
      currentPage: 1,
      count: 0,
      offset: 0,
      basket_id: null,
    };
  }

  async componentDidMount() {
    const { currentUserQuery } = this.props;
    if (!currentUserQuery.loading && !currentUserQuery.error) {
      this.setState({ roles: currentUserQuery.currentUserContext.roles }, () =>
        this.checkDisable()
      );
    }
    let uid = localStorage.getItem("currentUid");
    let address = await axios.get(`${LAST_ADDRESS}/${uid}`);
    let lastAddress = _.find(
      address.data.startupaddresses,
      (add) => add.type === "last_user"
    );
    if (lastAddress) {
      this.improveLastAddress(lastAddress.address_info);
    }
    let dtrainingAddress = _.find(
      address.data.startupaddresses,
      (add) => add.type === "dab_mestrino"
    );
    dtrainingAddress &&
      (await this.setState({
        dtrainingAddress: dtrainingAddress.address_info,
      }));
    let baskets = await axios.get(`${GETBASKETS}/${uid}`);
    let basket = _.find(
      baskets.data,
      (basket) => basket[1].basket_type === "d_training"
    );
    if (basket) {
      let basket_id = basket[0].id;
      if (basket_id) {
        await this.setState({ basket_id });
      }
    }
  }

  checkDisable = () => {
    const { selectedLocation, selectedCategory, selectedBasket, roles } =
      this.state;
    switch (roles[0].targetId) {
      case "area_manager_italia":
        this.setState({
          selectedBasket: "area_manager_italia",
        });
        break;
      case "buyer_area_manager_export": {
        if (selectedLocation && selectedCategory) {
          this.setState({
            disable: false,
            selectedBasket: "business_area_budget",
          });
        } else {
          this.setState({ disable: true });
        }
        break;
      }
      case "shop_administrator":
      case "buyer_d_training": {
        if (selectedBasket) {
          this.setState({ disable: false });
        } else {
          this.setState({ disable: true });
        }
        break;
      }
      default:
        this.setState({ disable: false });
    }
  };

  searchHandler = async (value) => {
    this.setState({ loading: true, currentPage: 1, offset: 0 });
    let zone =
      this.state.selectedLocation !== null
        ? this.state.selectedLocation
        : "empty";
    let uid = localStorage.getItem("currentUid");
    let results = await axios.get(`${SEARCH_ADDRESS}/${value}/${zone}/${uid}`);
    this.setState({ loading: false, firstTimeSearch: false });
    if (results.data.status === 1) {
      this.renderAddress(results.data.data);
      this.setState({ results: addresses, count: addresses.length });
    } else {
      this.setState({ error: true });
    }
  };

  select = (value, key) =>
    this.setState({ [key]: value }, () => this.checkDisable());

  showModal = async () => {
    await this.setState({ showModal: !this.state.showModal });
  };

  renderAddress = (data) => {
    addresses = [];
    let customersData = data.customers;
    customersData.forEach((customer) => {
      let addressesData = customer.addresses;
      if (addressesData.length > 0) {
        addressesData.forEach((address) => {
          let improvedAddress = {};
          improvedAddress.agent_id = customer.identificativo_agente;
          improvedAddress.business_id = customer.business_id;
          improvedAddress.code = address.code;
          improvedAddress.country_description = address.country_description;
          improvedAddress.email = customer.mail;
          improvedAddress.name = customer.business_name;
          improvedAddress.phone = address.telephone;
          improvedAddress.place = address.town_description;
          improvedAddress.street = `${address.street_address} ${address.street_address2}`;
          improvedAddress.zipCode = address.postal_code;
          addresses.push(improvedAddress);
        });
      }
    });
  };

  improveLastAddress = async (lastAddress) => {
    improvedLastAddress.agent_id =
      lastAddress.field_internal_sales_representat.length > 0
        ? lastAddress.field_internal_sales_representat[0].value
        : "";
    improvedLastAddress.business_id =
      lastAddress.field_ship_to_business_partner.length > 0
        ? lastAddress.field_ship_to_business_partner[0].value
        : "";
    improvedLastAddress.code =
      lastAddress.field_ship_to_business_partner.length > 0
        ? lastAddress.field_ship_to_business_partner[0].value
        : "";
    improvedLastAddress.country_description =
      lastAddress.field_country.length > 0
        ? lastAddress.field_country[0].value
        : "";
    improvedLastAddress.email =
      lastAddress.field_email_address.length > 0
        ? lastAddress.field_email_address[0].value
        : "";
    improvedLastAddress.name =
      lastAddress.field_name.length > 0 ? lastAddress.field_name[0].value : "";
    improvedLastAddress.telephone =
      lastAddress.field_phone_number.length > 0
        ? lastAddress.field_phone_number[0].value
        : "";
    improvedLastAddress.place =
      lastAddress.field_city.length > 0 ? lastAddress.field_city[0].value : "";
    improvedLastAddress.street =
      lastAddress.field_street.length > 0
        ? lastAddress.field_street[0].value
        : "";
    improvedLastAddress.zipCode =
      lastAddress.field_zip_code_postal_code.length > 0
        ? lastAddress.field_zip_code_postal_code[0].value
        : "";
    await this.setState({ lastAddress: improvedLastAddress });
  };

  selectAddress = (selectedAddress, checked) => {
    if (checked) {
      this.setState({ selectedAddress, disableButton: !checked });
    } else {
      this.setState({ selectedAddress: null, disableButton: !checked });
    }
  };

  proceedToOrder = async () => {
    const { history } = this.props;
    const {
      selectedAddress,
      selectedCategory,
      selectedLocation,
      selectedBasket,
    } = this.state;
    await this.setState({ showModal: false });
    history.push({
      pathname: "/order-summary",
      state: {
        selectedAddress,
        selectedCategory,
        selectedLocation,
        selectedBasket,
      },
    });
  };

  modalCheck = async () => {
    const { roles, selectedBasket } = this.state;
    if (
      _.find(
        roles,
        (role) =>
          role.targetId === "buyer_d_training" ||
          role.targetId === "shop_administrator"
      ) &&
      selectedBasket === "agent"
    ) {
      await this.showModal();
    } else {
      await this.proceedToOrder();
    }
  };

  fetchMoreAddresses = (numPage) => {
    this.setState({ currentPage: numPage, offset: (numPage - 1) * 6 });
  };

  render() {
    const {
      roles,
      disableButton,
      lastAddress,
      showModal,
      selectedAddress,
      currentPage,
      count,
      offset,
      basket_id,
    } = this.state;
    const { getText, getTextModal } = this.props;
    if (getText.loading || getTextModal.loading) {
      return (
        <LoadingStyle>
          <Spinner size={150} />
        </LoadingStyle>
      );
    }
    if (getText.error || getTextModal.error) {
      return (
        <div>
          <h3>{I18n.t("errors.generalError")}</h3>
        </div>
      );
    }

    return (
      <GridContainerStyle>
        {showModal && (
          <Modal open={showModal}>
            <Message
              action={{
                label: I18n.t("buttons.proceedOrder"),
                onClick: this.proceedToOrder,
              }}
              actionSecondary={{
                label: I18n.t("buttons.cancel"),
                onClick: this.showModal,
              }}
              title={
                getTextModal.translationMetadataGraphql1View.results.length >
                  0 &&
                getTextModal.translationMetadataGraphql1View.results[0]
                  .fieldMainText
              }
              description={
                getTextModal.translationMetadataGraphql1View.results.length >
                  0 &&
                getTextModal.translationMetadataGraphql1View.results[0]
                  .fieldSubText
              }
            />
          </Modal>
        )}
        <PageHeaderWrapperStyle>
          <PageHeader
            title={
              getText.translationMetadataGraphql1View.results.length > 0 &&
              getText.translationMetadataGraphql1View.results[0].fieldMainText
            }
            description={
              getText.translationMetadataGraphql1View.results.length > 0 &&
              getText.translationMetadataGraphql1View.results[0].fieldSubText
            }
          />
        </PageHeaderWrapperStyle>
        <div>
          {_.find(roles, (role) => role.targetId === "buyer_agent") && (
            <div>
              <IconWithTitleWrapperStyle track>
                <IconWrapperStyle>
                  <ListActionIcon color="#004615" color2="#f2f5f3" size={50} />
                </IconWrapperStyle>
                <FullWidthStyle>
                  <TitleStyle withsubtitle>
                    {I18n.t("content.orderType")}
                  </TitleStyle>
                  <SubtitleStyle>
                    {I18n.t("content.orderTypeDesc")}
                  </SubtitleStyle>
                  <CategoryRowStyle>
                    <div>
                      <CategoryCardSelection
                        handleOnChange={() =>
                          this.select("HOMAGE", "selectedCategory")
                        }
                        icon="HomageOrderIcon"
                        iconSize="S"
                        lang={
                          localStorage.getItem("language")
                            ? localStorage.getItem("language")
                            : "it"
                        }
                        name={I18n.t("content.homage")}
                        checked={this.state.selectedCategory === "HOMAGE"}
                      />
                    </div>
                    <div>
                      <OrderColStyle>
                        <CategoryCardSelection
                          handleOnChange={() =>
                            this.select("SALES", "selectedCategory")
                          }
                          icon="AgentBudgetIcon"
                          iconSize="S"
                          lang={
                            localStorage.getItem("language")
                              ? localStorage.getItem("language")
                              : "it"
                          }
                          name={I18n.t("content.sale")}
                          checked={this.state.selectedCategory === "SALES"}
                        />
                      </OrderColStyle>
                    </div>
                  </CategoryRowStyle>
                </FullWidthStyle>
              </IconWithTitleWrapperStyle>
            </div>
          )}
          {_.find(
            roles,
            (role) =>
              role.targetId === "buyer_area_manager_export" ||
              role.targetId === "area_manager_italia"
          ) && (
            <div>
              <IconWithTitleWrapperStyle track>
                <IconWrapperStyle>
                  <ListActionIcon color="#004615" color2="#f2f5f3" size={50} />
                </IconWrapperStyle>
                <FullWidthStyle>
                  <TitleStyle withsubtitle>
                    {I18n.t("content.orderLocation")}
                  </TitleStyle>
                  <SubtitleStyle>
                    {I18n.t("content.orderLocationDesc")}
                  </SubtitleStyle>
                  <CategoryRowStyle>
                    <div>
                      <CountryCardSelection
                        handleOnChange={() =>
                          this.select("CEE", "selectedLocation")
                        }
                        checked={this.state.selectedLocation === "CEE"}
                        type="CEE"
                      />
                    </div>
                    <div>
                      <CountryCardSelection
                        handleOnChange={() =>
                          this.select("EXTRACEE", "selectedLocation")
                        }
                        checked={this.state.selectedLocation === "EXTRACEE"}
                        type="extraCEE"
                      />
                    </div>
                  </CategoryRowStyle>
                  <TitleStyle withsubtitle>
                    {I18n.t("content.orderType")}
                  </TitleStyle>
                  <SubtitleStyle>
                    {I18n.t("content.orderTypeDesc")}
                  </SubtitleStyle>
                  <CategoryRowStyle>
                    <div>
                      <CategoryCardSelection
                        handleOnChange={() =>
                          this.select("HOMAGE", "selectedCategory")
                        }
                        icon="HomageOrderIcon"
                        iconSize="S"
                        lang={
                          localStorage.getItem("language")
                            ? localStorage.getItem("language")
                            : "it"
                        }
                        name={I18n.t("content.homage")}
                        checked={this.state.selectedCategory === "HOMAGE"}
                      />
                    </div>
                    <div>
                      <OrderColStyle>
                        <CategoryCardSelection
                          handleOnChange={() =>
                            this.select("SALES", "selectedCategory")
                          }
                          icon="AgentBudgetIcon"
                          iconSize="S"
                          lang={
                            localStorage.getItem("language")
                              ? localStorage.getItem("language")
                              : "it"
                          }
                          name={I18n.t("content.sale")}
                          checked={this.state.selectedCategory === "SALES"}
                        />
                      </OrderColStyle>
                    </div>
                  </CategoryRowStyle>
                </FullWidthStyle>
              </IconWithTitleWrapperStyle>
            </div>
          )}
          {_.find(
            roles,
            (role) =>
              role.targetId === "shop_administrator" ||
              role.targetId === "buyer_admin"
          ) && (
            <div>
              <IconWithTitleWrapperStyle track>
                <IconWrapperStyle>
                  <ListActionIcon color="#004615" color2="#f2f5f3" size={50} />
                </IconWrapperStyle>
                <FullWidthStyle>
                  <TitleStyle withsubtitle>
                    {I18n.t("content.orderBudget")}
                  </TitleStyle>
                  <SubtitleStyle>
                    {I18n.t("content.orderBudgetDesc")}
                  </SubtitleStyle>
                  <CategoryRowStyle>
                    <div>
                      <CategoryCardSelection
                        handleOnChange={() =>
                          this.select("admin_budget", "selectedBasket")
                        }
                        icon="DabBudgetIcon"
                        iconSize="S"
                        lang={
                          localStorage.getItem("language")
                            ? localStorage.getItem("language")
                            : "it"
                        }
                        name="Dab Budget"
                        checked={this.state.selectedBasket === "admin_budget"}
                      />
                    </div>
                    {basket_id && (
                      <div>
                        <CategoryCardSelection
                          handleOnChange={() =>
                            this.select("d_training", "selectedBasket")
                          }
                          icon="TrainingIcon"
                          iconSize="S"
                          lang={
                            localStorage.getItem("language")
                              ? localStorage.getItem("language")
                              : "it"
                          }
                          name="D.Training Budget"
                          checked={this.state.selectedBasket === "d_training"}
                        />
                      </div>
                    )}
                    <div>
                      <CategoryCardSelection
                        handleOnChange={() =>
                          this.select("agent", "selectedBasket")
                        }
                        icon="AgentBudgetIcon"
                        iconSize="S"
                        lang={
                          localStorage.getItem("language")
                            ? localStorage.getItem("language")
                            : "it"
                        }
                        name="Agent Budget"
                        checked={this.state.selectedBasket === "agent"}
                      />
                    </div>
                  </CategoryRowStyle>
                </FullWidthStyle>
              </IconWithTitleWrapperStyle>
            </div>
          )}
          {_.find(roles, (role) => role.targetId === "buyer_d_training") && (
            <div>
              <IconWithTitleWrapperStyle track>
                <IconWrapperStyle>
                  <ListActionIcon color="#004615" color2="#f2f5f3" size={50} />
                </IconWrapperStyle>
                <FullWidthStyle>
                  <TitleStyle withsubtitle>
                    {I18n.t("content.orderBudget")}
                  </TitleStyle>
                  <SubtitleStyle>
                    {I18n.t("content.orderBudgetDesc")}
                  </SubtitleStyle>
                  <CategoryRowStyle>
                    {basket_id && (
                      <div>
                        <CategoryCardSelection
                          handleOnChange={() =>
                            this.select("d_training", "selectedBasket")
                          }
                          icon="TrainingIcon"
                          iconSize="S"
                          lang={
                            localStorage.getItem("language")
                              ? localStorage.getItem("language")
                              : "it"
                          }
                          name="D.Training Budget"
                          checked={this.state.selectedBasket === "d_training"}
                        />
                      </div>
                    )}
                    <div>
                      <CategoryCardSelection
                        handleOnChange={() =>
                          this.select("agent", "selectedBasket")
                        }
                        icon="AgentBudgetIcon"
                        iconSize="S"
                        lang={
                          localStorage.getItem("language")
                            ? localStorage.getItem("language")
                            : "it"
                        }
                        name="Agent Budget"
                        checked={this.state.selectedBasket === "agent"}
                      />
                    </div>
                  </CategoryRowStyle>
                </FullWidthStyle>
              </IconWithTitleWrapperStyle>
            </div>
          )}
          <DeselectedAreaStyle disable={this.state.disable}>
            <OrderRowStyle>
              <OrderColStyle third>
                <IconWithTitleWrapperStyle border>
                  <IconWrapperStyle>
                    <PositionActionIcon
                      color="#004615"
                      color2="#f2f5f3"
                      size={50}
                    />
                  </IconWrapperStyle>
                  <div>
                    <TitleStyle>{I18n.t("content.lastOrder")}</TitleStyle>

                    <div>
                      {lastAddress && (
                        <AddressCardSelection
                          country={improvedLastAddress.country_description}
                          checked={
                            selectedAddress &&
                            selectedAddress.code === improvedLastAddress.code
                          }
                          email={improvedLastAddress.email}
                          handleOnChange={({ checked }) =>
                            this.selectAddress(improvedLastAddress, checked)
                          }
                          iconSize="S"
                          lang={
                            localStorage.getItem("language")
                              ? localStorage.getItem("language")
                              : "it"
                          }
                          name={improvedLastAddress.name}
                          phone={improvedLastAddress.phone}
                          place={improvedLastAddress.place}
                          street={improvedLastAddress.street}
                          zipCode={improvedLastAddress.zipCode}
                        />
                      )}
                    </div>
                  </div>
                </IconWithTitleWrapperStyle>
              </OrderColStyle>
              <OrderColStyle>
                <InputSearchWrapper>
                  <InputSearch
                    disabled={false}
                    expanded={false}
                    label={I18n.t("content.searchAddress")}
                    onSearchClick={(value) => this.searchHandler(value)}
                    placeholder={I18n.t("content.searchAddress")}
                  />
                </InputSearchWrapper>
                <div>
                  {this.state.error && (
                    <div>
                      <h3>{I18n.t("errors.addressesError")}</h3>
                    </div>
                  )}
                  {this.state.loading && (
                    <LoadingStyle small>
                      <Spinner size={100} />
                    </LoadingStyle>
                  )}
                  {addresses.length === 0 && !this.state.firstTimeSearch && (
                    <div>
                      <h3>{I18n.t("errors.addressNotFound")}</h3>
                    </div>
                  )}
                  {addresses.length > 0 && !this.state.loading && (
                    <ResultsWrapperStyle>
                      {addresses.slice(offset, offset + 6).map((address) => {
                        return (
                          <div key={`${address.code}-${address.name}`}>
                            <AddressCardSelection
                              country={address.country_description}
                              checked={
                                selectedAddress &&
                                selectedAddress.code === address.code
                              }
                              email={address.email}
                              handleOnChange={({ checked }) =>
                                this.selectAddress(address, checked)
                              }
                              iconSize="S"
                              lang={
                                localStorage.getItem("language")
                                  ? localStorage.getItem("language")
                                  : "it"
                              }
                              name={address.name}
                              phone={address.phone}
                              place={address.place}
                              street={address.street}
                              zipCode={address.zipCode}
                            />
                          </div>
                        );
                      })}
                      {count > 1 && (
                        <Pagination
                          currentPage={currentPage}
                          handleNavigateToPage={(props) =>
                            this.fetchMoreAddresses(props)
                          }
                          itemsPerPage={6}
                          itemsTotalCount={count}
                          rangePageDisplayed={7}
                        />
                      )}
                    </ResultsWrapperStyle>
                  )}
                </div>
              </OrderColStyle>
            </OrderRowStyle>
            {!disableButton && (
              <ButtonWrapperStyle>
                <Button
                  icon={null}
                  iconOrientation="top"
                  id="proceed-checkout-2"
                  label={I18n.t("buttons.proceedOrder")}
                  onClick={() => this.modalCheck()}
                  onMouseEnter={function noRefCheck() {}}
                  onMouseLeave={function noRefCheck() {}}
                  size="S"
                />
              </ButtonWrapperStyle>
            )}
          </DeselectedAreaStyle>
        </div>
      </GridContainerStyle>
    );
  }
}

export default compose(
  graphql(currentUserQuery, {
    name: "currentUserQuery",
  }),
  graphql(getText, {
    name: "getText",
    options: (props) => ({
      variables: {
        machineName: "order_details",
        lang: localStorage.getItem("language")
          ? localStorage.getItem("language")
          : "it",
      },
    }),
  }),
  graphql(getText, {
    name: "getTextModal",
    options: (props) => ({
      variables: {
        machineName: "order_details_budget_modal",
        lang: localStorage.getItem("language")
          ? localStorage.getItem("language")
          : "it",
      },
    }),
  }),
  graphql(productByCode, {
    name: "productByCode",
    options: (code) => ({
      variables: {
        code: "60184428",
      },
    }),
  }),
  graphql(createNodeCartLineItem, {
    name: "createNodeCartLineItem",
  }),
  graphql(createNodeCartLineItemWithSizes, {
    name: "createNodeCartLineItemWithSizes",
  }),
  graphql(deleteNodeCartLineItem, {
    name: "deleteNodeCartLineItem",
  }),
  graphql(currentUserCart, {
    name: "currentUserCart",
    options: (props) => ({
      variables: {
        id: localStorage.getItem("currentUid"),
        lang: localStorage.getItem("language")
          ? localStorage.getItem("language")
          : "it",
      },
    }),
  }),
  graphql(currencyById, {
    name: "currencyById",
    options: (props) => ({
      variables: {
        id: localStorage.getItem("currency")
          ? localStorage.getItem("currency")
          : localStorage.getItem("defaultCurrency"),
      },
    }),
  })
)(withRouter(OrderDetails));



// WEBPACK FOOTER //
// ./src/components/orderDetails/index.js